import { BodyCopy } from '@xing-com/typography';

import { CompanyLink } from './company-link';

type Props = {
  link?: string;
  name?: string;
};

export const CompanyName: React.FC<Props> = ({ link, name }) => {
  return (
    <CompanyLink link={link}>
      <BodyCopy
        noMargin
        size="medium"
        sizeConfined="xlarge"
        data-testid="job-details-company-info-name"
      >
        {name}
      </BodyCopy>
    </CompanyLink>
  );
};
